import { WebSection } from '@wbk/contentful/api';
import { ImageWithPlaceholder, Typography } from '@wbk/ui';
import ScrollTitle from '@/components/ui/ScrollTitle';

type Props = {
  section?: WebSection;
};

const HowToUse = ({ section }: Props) => {
  if (!section?.contentCollection?.items.length) return null;

  return (
    <div className='container-padding container'>
      <div className='container px-3 xl:px-0'>
        <div className='space-y-6'>
          <ScrollTitle title={section?.title || ''} />

          <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3'>
            {section?.contentCollection?.items.map((item, index) => {
              if (item?.__typename !== 'WebCard') return <div key={index} />;

              return (
                <div
                  className='flex items-center gap-4 rounded-[14px] md:flex-col md:justify-center md:text-center'
                  key={index}
                >
                  <div className='rounded-full bg-white/10 p-4'>
                    <ImageWithPlaceholder
                      src={item?.image?.url || ''}
                      alt={item?.image?.title || 'Guide Image'}
                      className='size-6 object-cover md:size-8'
                      draggable={false}
                    />
                  </div>
                  <div className='flex flex-col gap-4'>
                    <div className='flex flex-col'>
                      <Typography as='h4' className='!text-body-M font-semibold'>
                        {item?.title}
                      </Typography>
                      <Typography as='p' className='!text-body-XS'>
                        {item?.subtitle}
                      </Typography>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToUse;
